import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios';

Vue.use(Vuex);
const state = {
  touristInfo: [{
    id: "",
    name: "",
    idcard: "",
    phone: "",
    price: "",
    idType: "0",
    gender: 0,
    birthday:'',
    gatherPlaceId:''
}],
defaultpricelist:'',
  // BASEURL: 'http://dev.polecloud.net/1778',
  //正式
   BASEURL:'https://www.1778hw.com/1778',
  //  BASEURL:'http://192.168.10.10:8091/1778',
  //  BASEURL:'http://localhost:8091/1778',
  downloadNav: [],//下载中心类别
  enterpriseNav: [],//入驻平台类别
  memberInfo: '',// 用户信息
  webInfo: {},//网站基本信息
  jwt: '',
  Rusult:'',
  RusultA:'',//高企结果
  serviceArray: [],
  // 默认集合地
  dafaultGatherPlaceId:'',
  // 默认集合地点列表
  defaultGatherList:[],
  //线路图标快捷路口
  lineIconArray:[]
  //authorizeUrl: 'http://gdufe.polecloud.net/gdufe/match/authorize.html',
  //wxappid: 'wxd4709d564c8cb70d'
}

const actions= {
  //下载中心类别
  getNavDw({state,commit}){
    axios.get(`/mobile/cmDataDownload/getDataDictionaryTypeById.jhtml`,{
          params: {
              typeId: 8
          }
    }).then((res) => {
      if (res.data.success) {
        //下载中心类别
        //commit('savedownloadNav', res.data.output)
        let dwArray = res.data.output
        dwArray.map((res, index) => {
          axios
          .get(
            `/mobile/cmDataDownload/getCmDataDownloadPage.jhtml`,
            {
              params: {
                levelType: -1,
                title: "",
                pubUnitName: "",
                state: 0,
                dowTypeId: res.id,
                pageNumber: 1,
                pageSize: 10
              }
            }
          )
          .then(res2 => {
            if (res2.data.success) {
              dwArray[index].list = res2.data.output.list;
              //console.log(dwArray);
            } else {
              this.$message("系统繁忙，请稍后再试~");
            }
          });
        });
        commit('savedownloadNav', dwArray)
      } else {

      }
    })
  },
  //入驻平台类别
  getNavEp({state,commit}){
    axios.get(`/mobile/cmDataDownload/getDataDictionaryTypeById.jhtml`,{
          params: {
              typeId: 9
          }
    }).then((res) => {
      if (res.data.success) {
        //入驻平台类别
        //commit('saveenterpriseNav', res.data.output)
        let epArray = res.data.output
        epArray.map((res, index) => {
          axios
          .get(
            `/mobile/cmEntryPlatform/getCmEntryPlatformPage.jhtml`,
            {
              params: {
                title: "",
                pubUnitName: "",
                state: 0,
                typeId: res.id,
                pageNumber: 1,
                pageSize: 10
              }
            }
          )
          .then(res2 => {
            if (res2.data.success) {
              epArray[index].list = res2.data.output.list;
              //console.log(epArray);
            } else {
              this.$message("系统繁忙，请稍后再试~");
            }
          });
        });
        commit('saveenterpriseNav', epArray)
      } else {

      }
    })
  },
  //服务列表
  getService({state,commit}){
    axios.get(`/mobile/cmInnSer/getCmInnSerPage.jhtml`,{
      params: {
          pageNumber: 1,
          pageSize: 100,
      }
    }).then((res) => {
      this.loading = false;
      if (res.data.success) {
        commit('saveServiceArray', res.data.output.list)
      } else {
        this.$message('系统繁忙，请稍后再试~');
      }
    })
  },
  //用户信息
  getMember({state,commit}){
    axios.get(`/mobile/member/getMember.jhtml`)
    .then((res) => {
      commit('savememberInfo', res.data.returnValue)
    })
    .catch((err)=>{
    })
  },
  //网站基本信息
  getWebInfo({state,commit}){
    axios.get(`/mobile/cmWebBasicConfig/getCmWebBasicConfigById.jhtml`).then((res) => {
      this.loading = false;
      if (res.data.success) {
        commit('saveWebInfo', res.data.output)
      } else {

      }
    })
  },

  lineIconList({state,commit}) {
    axios.get(`/mobile/line/lineIconList.jhtml`).then(res => {
      if (res.data.success) {
        commit('saveLineIconArray', res.data.returnValue)
        
      }
    });
  },
     //获取默认游客
     getTour({
      state,
      commit
  }) {
      let pageList = [];
      axios.get(`favoriteContacts/getFavoriteContacts.jhtml`, {
              params: {
                  pageNumber: 1,
                  pageSize: 10
              }
          })
          .then((res) => {
              if (res.data.returnValue.content.length > 0) {
                  res.data.returnValue.content.map((res2, index) => {
                      let pageItem = {};
                      if (res2.isdefault == 1) {
                          pageItem.id = res2.id;
                          pageItem.name = res2.contactName;
                          pageItem.idcard = res2.idNumber;
                          pageItem.phone = res2.mobile;
                          pageItem.price = state.defaultpricelist;
                          console.log(state.dafaultGatherPlaceId)
                          pageItem.gatherPlaceId = state.dafaultGatherPlaceId;
                          pageItem.idType = res2.idType.toString();
                          pageItem.gender = res2.gender;
                          pageItem.birthday = res2.birthday;
                          console.log("pageItem")
                          console.log(pageItem)
                          console.log("gatherPlaceIdA")
                          console.log(pageItem.gatherPlaceId)
                          pageList.push(pageItem);
                          console.log(pageList)
                      }
                  });
                  commit('savetouristInfo', pageList)
              }


              // localStorage.setItem('memberInfo',JSON.stringify(res.data.returnValue))
          })
          .catch((err) => {})
  },
};


const mutations = {
  savedefaultpricelist(state, item) {
    state.defaultpricelist = item
},
saveDefaultGatherList(state, item) {
  state.defaultGatherList = item
},
saveDefaultGatherPlaceId(state, item) {
    state.dafaultGatherPlaceId = item
},
  savetouristInfo(state, item) {
    state.touristInfo = item
},
  saveResult(state, token){
    state.Rusult=token
  },
  saveResultA(state, token){
    state.RusultA=token
  },//高企结果
  saveToken(state, token) {
    state.jwt = token
  },
  savememberInfo(state, item) {
    state.memberInfo = item
  },
  savedownloadNav(state, item) {
    state.downloadNav = item
  },
  saveenterpriseNav(state, item) {
    state.enterpriseNav = item
  },
  saveServiceArray(state, item) {
    state.serviceArray = item
  },
  saveWebInfo(state, item) {
    state.webInfo = item
  },
  saveLineIconArray(state, item) {
    state.lineIconArray = item
  },
  
}

const getters = {

};



export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js